module.exports = __webpack_public_path__ + "static/thumbnail_selected-db49be424f25e945032ccd2a4a4d4e05.png";